document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const productJsonEl = section.querySelector('[data-product-json]');
    if (!productJsonEl) return;
    let product;
    try { product = JSON.parse(productJsonEl.textContent); } catch(e) { return; }

    const selects = [...section.querySelectorAll('[data-option-select]')];
    const variantInput = section.querySelector('[data-variant-id-input]');
    const stickyInput = document.querySelector('[data-sticky-variant-id-input]');
    const addButton = section.querySelector('[data-add-button]');
    const stickyButton = document.querySelector('[data-sticky-button]');
    const priceEl = section.querySelector('[data-product-price]');
    const stickyPrice = document.querySelector('[data-sticky-price]');
    const mainImage = section.querySelector('#ProductMainImage');
    const thumbs = [...section.querySelectorAll('.product-thumb')];

    const money = (cents) => {
      const amount = (cents / 100).toLocaleString('en-US', { style: 'currency', currency: Shopify?.currency?.active || 'USD' });
      return amount.replace('.00','');
    };

    const setMainImage = (src, imageId) => {
      if (!mainImage || !src) return;
      mainImage.src = src;
      mainImage.srcset = '';
      thumbs.forEach(t => t.classList.toggle('is-active', String(t.dataset.imageId) === String(imageId)));
    };

    thumbs.forEach((thumb) => thumb.addEventListener('click', () => setMainImage(thumb.dataset.fullSrc, thumb.dataset.imageId)));

    const findVariant = () => {
      const selected = selects.map(s => s.value);
      return product.variants.find(v => v.options.every((opt, i) => opt === selected[i]));
    };

    const updateVariant = () => {
      const variant = findVariant();
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (stickyInput) stickyInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (stickyPrice) stickyPrice.textContent = money(variant.price);
      if (addButton) { addButton.disabled = !variant.available; addButton.textContent = variant.available ? 'Add to Cart' : 'Sold Out'; }
      if (stickyButton) { stickyButton.disabled = !variant.available; }

      const imageId = variant.featured_image && variant.featured_image.id;
      const thumb = imageId ? thumbs.find(t => String(t.dataset.imageId) === String(imageId)) : null;
      if (thumb) setMainImage(thumb.dataset.fullSrc, imageId);
    };

    selects.forEach(s => s.addEventListener('change', updateVariant));
  });
});
